import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'newauthfaq',
  imports: [],
  templateUrl: './newauthfaq.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './newauthfaq.component.css'
})
export class NewauthfaqComponent {

}
